export function isCombo(id?: string | null) {
  return id?.startsWith('_combonode_')
}
